import type { WidgetSession } from './types'

const STORAGE_KEY = 'tebuto-widget-session'

function isBrowser(): boolean {
    return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined'
}

function isSessionExpired(session: WidgetSession): boolean {
    const expiresAt = Date.parse(session.expiresAt)
    if (Number.isNaN(expiresAt)) {
        return true
    }
    return expiresAt <= Date.now()
}

export function loadWidgetSession(): WidgetSession | null {
    if (!isBrowser()) return null
    try {
        const raw = window.sessionStorage.getItem(STORAGE_KEY)
        if (!raw) return null
        const parsed = JSON.parse(raw) as WidgetSession
        if (!parsed?.accessToken || !parsed?.expiresAt || !parsed?.client) {
            return null
        }
        if (isSessionExpired(parsed)) {
            clearWidgetSession()
            return null
        }
        return parsed
    } catch {
        return null
    }
}

export function storeWidgetSession(session: WidgetSession): void {
    if (!isBrowser()) return
    try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session))
    } catch {
        /* ignore storage failures (quota, private mode, etc.) */
    }
}

export function clearWidgetSession(): void {
    if (!isBrowser()) return
    try {
        window.sessionStorage.removeItem(STORAGE_KEY)
    } catch {
        /* ignore */
    }
}
